import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box } from '@mui/material';
import { implantNameSuggestions } from '../../constants/options';

const NursingNotesSection = ({ formData, handleChange }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 9: Nursing Notes & Implants
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Nursing Notes"
            multiline
            rows={4}
            fullWidth
            name="nurses_notes"
            value={formData.nurses_notes || ''}
            onChange={handleChange}
            variant="outlined"
          />
        </Grid>
        
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#008080' }}>
            Name of the Implant
          </Typography>
          <Autocomplete
            freeSolo
            options={implantNameSuggestions}
            value={formData.name_of_implant || ''}
            onChange={(_, newVal) => handleChange({ target: { name: "name_of_implant", value: newVal } })}
            renderInput={(params) => (
              <TextField
                {...params}
                multiline
                rows={5}
                variant="outlined"
                fullWidth
                label="Specify Implants (Serial No, Batch, Expiry, etc.)"
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NursingNotesSection;
